module.exports = __webpack_public_path__ + "img/internal-notifications-normal.35a2a6fd.svg";